import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';
import { companiesQueryKeys } from '@/modules/companies/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

type DeleteCompanyNoteParams = {
  companyId: string;
  noteId: string;
};

export const useDeleteCompanyNoteMutation = () => {
  return useMutation({
    mutationFn: async ({ companyId, noteId }: DeleteCompanyNoteParams) => {
      await fetchClient.DELETE(endpoints.companyNote, {
        params: { path: { companyId, id: noteId } },
      });
    },
    onSettled: (_data, _error, { companyId }) => {
      invalidateQuery(companiesQueryKeys.notes(companyId))();
    },
  });
};
